import React from "react";

type Props = {
    meta: {
        error: string[],
        touched: boolean
    }
}

function Errors(props: Props) {
    const {meta} = props;
    if (meta.error?.length > 0 && meta.touched) {
        return (
            <div>
                {
                    meta.error.map(err => (
                        <div style={{color: 'red'}} key={err}>{err}</div>
                    ))
                }
            </div>
        )
    }

    return null;
}

export default Errors